<section class="flex-column h-100 mr-md-3 mt-5">
    <div class="row mx-0">
        <div class="col-12">
            <canvas class="myChart" [id]="chartId"></canvas>
        </div>
        <div class="col-6 pt-5 pl-5">
        </div>
    </div>
</section>